import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import React from 'react';
import TransparentLocator from '../Icons/TransparentLocator';
import Protector from '../Icons/Protector';
import Button from '@/shared/Button';
import Span from '@/shared/Span';

type LocationPopupProps = {
  onContinue: () => void;
};
function LocationPermission({ onContinue }: LocationPopupProps) {
  return (
    <Div className="p-s6 flex flex-col gap-s5">
      <Paragraph className="text-h-2">Location Access Required</Paragraph>
      <Div className="flex flex-col gap-s5">
        <Div className="p-s5 flex border border-co-subtle rounded-cxs gap-s4">
          <Span>
            <TransparentLocator />
          </Span>
          <Paragraph className="text-body-lg  text-cti-secondary">
            Please enable location access from your device or browser.
          </Paragraph>
        </Div>
        <Div className="p-s5 flex border border-co-subtle rounded-cxs gap-s4">
          <Span>
            <Protector />
          </Span>
          <Paragraph className="text-body-lg  text-cti-secondary">
            A precise location will ensure our technician reaches you accurately and on time.
          </Paragraph>
        </Div>
      </Div>

      <Button className="w-full" theme="secondary" onClick={onContinue}>
        Continue
      </Button>
    </Div>
  );
}

export default LocationPermission;
